<script>
    let className = '';
    export { className as class };
    export let sm = false;
    export let xl = false;
    export let invert = false;
    export let tag = 'h3';
</script>

<svelte:element
    this={tag}
    class="{sm ? 'font-extrabold' : 'font-semibold'} text-balance
    {xl
        ? 'text-2xl md:text-4xl leading-tight'
        : sm
        ? 'text-base leading-[1.5555556] md:text-lg md:leading-[1.5]'
        : 'text-xl leading-tight'}
    {invert ? 'text-symbols-invert-highlight' : 'text-symbols-highlight'}
    {className}"
>
    <slot />
</svelte:element>
